import styled from "styled-components";
import { Box } from "@vinomofo/components";
import { VideoBackground } from "./VideoBackground";

const HeroContainer = styled(Box)`
  color: #f7f7f7;
  background-color: #0000;
  background-image: none;
  background-position: 0 0;
  background-size: auto;
  padding: 0;
  position: static;
`;

interface VideoHeroProps {
  url?: string;
  imageBackground?: string;
}

const VideoHero = ({ url, imageBackground }: VideoHeroProps) => {
  return (
    <HeroContainer
      width="100%"
      maxWidth="100%"
      ml="auto"
      mr="auto"
      height={["40vh", "50vh", "70vh"]}
    >
      <VideoBackground videoSrc={url} heroImageBackground={imageBackground} />
    </HeroContainer>
  );
};

export { VideoHero };
